import $ from 'jquery';
import TraversableMenu from 'traversable_menu';

$(function () {
  const $menuBt = $('.menu-toggle');
  const $overlay = $('.header__overlay');
  const $trigger = $('.header__search, .searchform__close');
  const $textbox = $('.searchform--md');
  const $inputField = $('.searchform--md input');
  const $firstLevel = $('.header__primary-navigation .menu--level-0 > .menu__items > .menu__item > .menu__link');

  let state = {
    mode: 'FULL',
    height: 0,
    menu: false,
  };

  function checkScroll() {
    const scrollMode = $(window).scrollTop() > 0 ? 'COMPACT' : 'FULL';
    if (scrollMode !== state.mode) {
      state.mode = scrollMode;
      $('body').toggleClass('header--compact', scrollMode === 'COMPACT');
    }
  }

  function onEscapeKey(e) {
    if (e.keyCode === 27) {
      document.removeEventListener('keydown', onEscapeKey, false);
      $('.menu__item.is-expanded').removeClass('is-expanded').attr('aria-expanded', 'false')
        .next('.submenu').attr('aria-hidden', 'true');
      $textbox.removeClass('is-expanded');
      $trigger.removeClass('is-expanded');
      $menuBt.removeClass('is-active');
      $('body').removeClass('header--show-menu');
    }
  }

  function onMenuBtClick(e) {
    e.preventDefault();
    $menuBt.toggleClass('is-active');
    $('body').toggleClass('header--show-menu');
    if ($menuBt.hasClass('is-active')) {
      document.addEventListener('keydown', onEscapeKey, false);
    } else {
      document.removeEventListener('keydown', onEscapeKey, false);
    }
  }

  function onTriggerClick(e) {
    $textbox.toggleClass('is-expanded');
    $trigger.toggleClass('is-expanded');
    document.addEventListener('keydown', onEscapeKey, false);
    if ($textbox.hasClass('is-expanded')) {
      $inputField.focus();
    } else {
      $trigger.focus();
      document.removeEventListener('keydown', onEscapeKey, false);
    }
  }

  function onMenuItemFocus(e) {
    const $focused = $(e.target);
    const $submenu = $focused.next('.submenu');
    if ($submenu.length) {
      $focused.attr('aria-expanded', 'true').addClass('is-expanded');
      $submenu.attr('aria-hidden', 'false');
      $focused.on('keydown.submenu', (event) => {
        if (event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          if ($focused.hasClass('is-expanded')) {
            $focused.removeClass('is-expanded').attr('aria-expanded', 'false');
            $submenu.attr('aria-hidden', 'true');
          } else {
            $focused.addClass('is-expanded').attr('aria-expanded', 'true');
            $submenu.attr('aria-hidden', 'false');
            $submenu.find('.menu__link').first().focus();
          }
        }
      });
    }
  }

  // Bind events
  $menuBt.on('click', onMenuBtClick);
  $overlay.on('click', onMenuBtClick);
  $trigger.on('click', onTriggerClick);
  $firstLevel.on('focus', onMenuItemFocus);
  $(window).on('scroll', checkScroll);
  checkScroll();

  // Init TraversableMenu
  new TraversableMenu({
    selectors: {
      panels_container: '.header__menu #block-mainnavigation',
      menu_item_active: '.menu-item--active-trail',
      menu_item: 'li.menu-item__link',
      menu_item_link: '.link a',
    },
    active: {
      find_by_class: false,
      find_by_url: true,
    },
  });
});



// WEBPACK FOOTER //
// ./Components/BlockHeaderMain/script.js